<template>
  <div id="app">
    <img id="logo" src="./assets/methopedia-logo.png">
    <stories></stories>
  </div>
</template>

<script>
import stories from './components/Stories'
export default {
  name: 'app',
  components: {
    stories
  },
  data () {
    return {}
  }
}
</script>

<style>
body{
  background-color: #CEF6EC;
} 
#logo{
  width: 400px;
} 
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// App.vue?77ff4c78